export default __webpack_public_path__ + "static/media/inhouse-icon4.e0cae5d4.svg";